<template>

    <totals
        :totals-uri="route('api.v1.hr.users.overtime.totals', {id:getHrUser.uuid})"
        :corrections-uri="route('api.v1.hr.users.overtime.corrections.add', {id:getHrUser.uuid})"
    ></totals>

</template>

<script>

import {mapGetters} from "vuex";
import Totals from "../../../components/HR/Overtime/Totals";

export default {

    components: {
        Totals,
    },

    computed: {
        ...mapGetters([
            'getHrUser',
        ]),
    },

    metaInfo: {
        title:'Overuren totalen bekijken',
    },

    name:'HrUsersOvertimeTotals',

}

</script>
